import * as queryString from 'query-string';
import {I_CP, IEnvironment} from '../../middleware/envi';
import * as _ from 'lodash';
import {func} from 'prop-types';

export function addUcCommonParam(params, ENVI_INFO?: IEnvironment, pageQuery?) {
  // console.log('addUcCommonParam', JSON.stringify(params, null, 4));
  const queries = pageQuery || queryString.parse(location.search, {arrayFormat: 'bracket'});
  ENVI_INFO = ENVI_INFO || (window as any)._ENVI_INFO;

  const queryParamKey = '' || [];
  queryParamKey.push('uc_param_str');
  const keyMaps = {
    li: 'lb', gi: 'gp', wi: 'wf', ni: 'nn', cp: 'pc', gd: 'td', ds: 'ut', ud: 'ai',
  };

  if (!queries.uc_param_str) {
    queries.uc_param_str = 'dnnivebifrmintcpgieiwidsudsvssnwpflamtch';
  }

  if (queries.uc_param_str) {
    const ucParamStr = queries.uc_param_str;
    for (let t = 0; t < ucParamStr.length / 2; t++) {
      const uckey = ucParamStr.substr(t * 2, 2);
      if (queries[uckey]) {
        queryParamKey.push(uckey);
      } else if (keyMaps.hasOwnProperty(uckey) && queries[keyMaps[uckey]]) {
        // 兼容浏览器客户端10.10以后，ds公参丢失问题,匹配缺失的公参
        queryParamKey.push(keyMaps[uckey]);
      }
    }
  }

  if (queries.lang && !queries.set_lang) {
    queries.set_lang = queries.lang;
  }

  for (let i = 0; i < queryParamKey.length; i++) {
    const k2 = queryParamKey[i];
    if (queries[k2] && !params[k2]) {
      params[k2] = queries[k2];
    }
  }

  // 适配ucnews 外部导流相关参数
  if (params.uc_news_app) {
    params.app = params.uc_news_app;
  }
  if (params.uc_news_entry) {
    params.entry = params.uc_news_entry;
  }
  if (params.uc_news_entry1) {
    params.entry1 = params.uc_news_entry1;
  }
  if (params.uc_news_entry2) {
    params.entry2 = params.uc_news_entry2;
  }
  // 使用服务器判断的参数值填充版本参数，适配各个版本接入端传参时参数混乱的问题
  if (ENVI_INFO.ver) {
    params.ver = ENVI_INFO.ver;
  }
  if (ENVI_INFO.ver && ENVI_INFO.client === 'ucbrowser') {
    params.brow_ver = ENVI_INFO.ver;
  }
  if (ENVI_INFO.sver) {
    params.sver = ENVI_INFO.sver;
  } else if (ENVI_INFO.isUcMini) {
    params.sver = 'release';
    params.brow_sver = 'release';
  }
  if (ENVI_INFO.sver && ENVI_INFO.client === 'ucbrowser') {
    params.brow_sver = ENVI_INFO.sver;
  }
  if (!params.lang && ENVI_INFO.language) {
    params.lang = ENVI_INFO.language;
  }
  if (!params.site) {
    params.site = ENVI_INFO.siteKey;
  }

  // 某些版本mini浏览器，公参中utdid相关参数为空，而且存在某些加密，某些不加密的问题，现在统一使用dn通过无线保镖算法加密的自定义ut来取代
  // if (ENVI_INFO.isUcMini) {
  //   params.ut = encodeURIComponent(ENVI_INFO.emptyUt || '');
  // }
  if (!params.app && ENVI_INFO && ENVI_INFO.client) {
    if (ENVI_INFO.isH5) {
      params.app = 'h5_iflow';
    } else if (ENVI_INFO.client === 'ucbrowser') {
      params.app = 'browser_iflow';
    } else if (ENVI_INFO.client === 'app') {
      params.app = 'app_iflow';
    }
  }
  // params.referrer = urllib.getReferrer();

  // 分享id不存在 不打点
  if (!params.shareid) {
    delete params.shareid;
  }

  // console.log('addUcCommonParam final', JSON.stringify(params, null, 4));
  return params;

}

export function getPageBizParam() {
  const keys = ['app',

    'uc_param_str', 'dn', 've', 'bi', 'fr', 'mi', 'nt', 'cp', 'wi', 'ds', 'ud',
    'sv', 'nw', 'pf', 'la', 'me', 'ef', 'ut', 'ch', 'lb', 'gp', 'wf', 'nn', 'pc', 'td', 'ai',

    'ver', 'sver', 'brow_ver', 'brow_sver',
    'lang', 'entry', 'entry1', 'entry2', 'ucid', 'service_ticket'];
  const r = _.pick(queryString.parse(location.search, {arrayFormat: 'bracket'}), keys);
  // console.log('getPageBizParam', JSON.stringify(queryString.parse(location.search, {arrayFormat: 'bracket'}), null, 4));
  return r;
}

export function getCpParams(envi?: IEnvironment): I_CP {
  // 国家，省，市 等数据，上报的时候一般要带上
  envi = envi || window._ENVI_INFO;
  return envi.cp;
}

export function getFrontEndInfo() {
  return {
    fe_type: window.__FE_TYPE,
    fe_ver: process.env.FE_VER,
    fe_is_push: isPushEntering() ? 1 : 0,
  };
}

export function isPushEntering(): boolean {
  const q = queryString.parse(location.search, {arrayFormat: 'bracket'});
  return (q.entry1 && /^push/i.test(q.entry1 as string) && q.uc_biz_str);
}

export function getShareOutParam() {
  const keys = ['channel_id', 'app', 'uc_param_str', 'ver', 'sver', 'entry', 'stat_entry'];
  return _.pick(queryString.parse(location.search, {arrayFormat: 'bracket'}), keys);
}

export function funcGetLocationSearchObj(): any {
  const windowOriginQuery = window.location.search;
  let originQuery: string = window.location.search;
  if (windowOriginQuery.indexOf('?') === 0) {
    originQuery = windowOriginQuery.slice(1);
  }
  const parsed = queryString.parse(originQuery);
  const obj: any = {};
  _.forEach(parsed, (queryVal: string, queryKey: string) => {
    if (queryKey !== '' && queryKey !== '?') {
      obj[queryKey] = queryVal;
    }
  });
  return obj;
}
